import React from "react";
import * as R from "ramda";
import { Popconfirm } from "antd";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import * as gtag from "../lib/gtag";
import { canCreateOpportunity as canCreateOpportunitySelector } from "../store/selectors/user";

import Button from "./Button";

export default function NewOpportunityBtn({ canCreate = true, team }) {
  const company = useSelector(({ company }) => company);
  const userCanCreateOpportunity = useSelector(({ user }) =>
    canCreateOpportunitySelector(user)
  );
  const history = useHistory();
  const { t } = useTranslation();

  const [draftOpportunity, setDraftOpportunity] = React.useState();

  React.useEffect(() => {
    if (localStorage.getItem("opportunity")) {
      try {
        const draftOpt = JSON.parse(localStorage.getItem("opportunity"));
        setDraftOpportunity(draftOpt);
      } catch (e) {}
    }
  }, []);

  if (!userCanCreateOpportunity) return null;

  return (
    <Popconfirm
      disabled={!draftOpportunity || !canCreate}
      placement="topLeft"
      title={t("opportunities:continueEditingOpportunity", {
        opportunityTitle: R.pathOr("", ["selected", "title"], draftOpportunity)
      })}
      cancelText={t("opportunities:createNew")}
      okText={t("opportunities:continueEditing")}
      onConfirm={() => {
        team
          ? history.push(`/oportunidades/nueva?team=${team.id}`)
          : history.push("/oportunidades/nueva");
      }}
      onCancel={() => {
        team
          ? history.push(`/oportunidades/nueva?team=${team.id}`)
          : history.push("/oportunidades/nueva");
        localStorage.removeItem("opportunity");
      }}
    >
      <Button
        style={{ minWidth: 180 }}
        disabled={!canCreate}
        onClick={() => {
          gtag.event({
            category: "Vacancies",
            action: "Vacancies.VacancyList.New",
            label: company.id
          });
          if (!draftOpportunity) {
            team
              ? history.push(`/oportunidades/nueva?team=${team.id}`)
              : history.push("/oportunidades/nueva");
          }
        }}
      >
        {t("opportunities:newOpportunity")}
      </Button>
    </Popconfirm>
  );
}
